/** @jsxImportSource @emotion/react */
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { chevronRightSvg } from '../../../assets/images';
import AuthorEmail from '../AuthorEmail';

interface VersionHistoryProps {
    versions: any[] | null;
    onClickRestoreVersion?: (e: any) => any;
}

interface PageSizes {
    [key: string]: any;
}

const VersionHistory = ({ versions, onClickRestoreVersion }: VersionHistoryProps) => {
    const [skip, setSkip] = useState<number>(0);
    const [take, setTake] = useState<number>(5);
    const [currentItems, setCurrentItems] = useState<any[] | null>(null);
    const pageSizes: PageSizes = {
        _2: 2,
        _5: 5,
        _10: 10,
        _25: 25,
        _50: 50,
        _100: 100,
        _All: 1000,
    };

    const loadNextPage = () => {
        setSkip(Math.max(skip + take));
    };

    const loadPrevPage = () => {
        setSkip(Math.max(0, skip - take));
    };

    const pageSizeChanged = (e: any) => {
        setTake(Number(e.target.value));
    };

    const restoreVersion = (event: any) => {
        onClickRestoreVersion && onClickRestoreVersion(event.target.value);
    };

    useEffect(() => {
        if (versions && versions.length > 0) {
            const last = skip + take;
            const currentVersions = versions.slice(skip, last);
            setCurrentItems(currentVersions);
        }
    }, [versions, skip, take]);

    return (
        <>
            {currentItems && (
                <div className="version-history">
                    <div className="versions">
                        {currentItems.map((v) => {
                            return (
                                <div className={'version-template'} key={v.versionNumber}>
                                    <div className={'version-info'}>
                                        <p className={'version-name'}>Version {v.versionNumber}</p>
                                        <p className={'version-date'}>
                                            {new Date(v?.lastModified).toLocaleString()}
                                        </p>
                                        <p className={'version-author'}>
                                            <AuthorEmail authorId={v.author} />
                                        </p>
                                    </div>
                                    <div className={'version-actions'}>
                                        <button
                                            className={'restore-button'}
                                            onClick={restoreVersion}
                                            value={v.versionNumber}
                                        >
                                            Restore
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="footer-pagination">
                        <Button
                            size="sm"
                            variant="outline"
                            disabled={skip <= 0}
                            onClick={loadPrevPage}
                        >
                            <img className="prev" src={chevronRightSvg} alt="load prev page" />
                        </Button>
                        <select value={take || 5} onChange={pageSizeChanged}>
                            {Object.keys(pageSizes).map((k: string) => (
                                <option key={k} value={pageSizes[k]}>
                                    {k.slice(1)}
                                </option>
                            ))}
                        </select>
                        <Button
                            size="sm"
                            variant="outline"
                            disabled={currentItems ? currentItems.length < take : false}
                            onClick={loadNextPage}
                        >
                            <img className="next" src={chevronRightSvg} alt="load next page" />
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default VersionHistory;
